/**
 * Zona horaria oficial de la federación. La categoría depende SOLO del año de
 * nacimiento, así que el año hay que leerlo siempre en esta zona: las Cloud
 * Functions corren en UTC y un nacimiento del 01/01 guardado como medianoche de
 * Madrid (2010-12-31T23:00:00Z) se leía allí como del año anterior, subiendo al
 * jugador una categoría (p. ej. 01/01/2011 → JUVENIL en vez de CADETE).
 */
const FEDERATION_TIME_ZONE = 'Europe/Madrid';

/** Fecha tal y como la guarda Firestore (Timestamp) o como llega del formulario. */
export type DateLike = Date | string | number | { toDate(): Date };

export const isAdult = (birthDate: DateLike) => calculateAge(birthDate) >= 18;

export function calculateAge(birthDate: DateLike): number {
  const birth = getZonedYearAndMonth(toDate(birthDate));
  const today = getZonedYearAndMonth(new Date());

  let age = today.year - birth.year;

  // La temporada arranca en julio: hasta entonces cuenta la del año anterior.
  if (today.month < 7) {
    age--;
  }

  return age;
}

/** Normaliza Timestamp (SDK web y firebase-admin), Date, ISO string o epoch. */
function toDate(value: DateLike): Date {
  if (value instanceof Date) return value;
  if (value && typeof (value as { toDate?: unknown }).toDate === 'function') {
    return (value as { toDate(): Date }).toDate();
  }
  return new Date(value as string | number);
}

/** Año y mes (1-12) de una fecha vistos desde la zona horaria de la federación. */
function getZonedYearAndMonth(date: Date): { year: number; month: number } {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: FEDERATION_TIME_ZONE,
    year: 'numeric',
    month: 'numeric',
  }).formatToParts(date);

  const part = (type: 'year' | 'month') => Number(parts.find((p) => p.type === type)?.value);

  return { year: part('year'), month: part('month') };
}
